import axios from 'axios'
import { getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import router from '@/router'

const request = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_TARGET : '/api', timeout: 30000 })

// 防重复跳转登录页
let isRedirecting = false

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) config.headers['Authorization'] = 'Bearer ' + token
  return config
}, error => Promise.reject(error))

request.interceptors.response.use(response => {
  const res = response.data
  // 业务级判断：后端统一响应体 R，成功码为 "0"（同时兼容历史 200/0，视为成功）
  const code = res ? res.code : undefined
  const isSuccess = code === undefined || code === null ||
    code === 0 || code === '0' || code === 200 || code === '200'
  if (!isSuccess) {
    const tip = (res && (res.msg || res.message)) || '请求失败'
    Message.error(tip)
    if (code === '401' || code === 401) {
      handleExpired()
    }
    return Promise.reject(new Error(tip))
  }
  return res
}, error => {
  // HTTP 级错误
  if (error.response) {
    const status = error.response.status
    if (status === 401) {
      const data = error.response.data
      Message.error((data && data.msg) || '登录已过期，请重新登录')
      handleExpired()
    } else {
      // 展示后端返回的具体原因（如 Unknown column、表不存在等），便于定位
      const data = error.response.data
      const tip = (data && (data.msg || data.message)) || (data && data.error) || ''
      Message.error(tip || `请求失败（${status}），请稍后重试`)
    }
  } else {
    Message.error('网络异常，请检查网络连接')
  }
  return Promise.reject(error)
})

function handleExpired() {
  if (isRedirecting) return
  // 登录页/注册页本身就不要求已登录，无需因 401 强制跳转
  const path = router.currentRoute && router.currentRoute.path
  if (path === '/login' || path === '/register') return
  isRedirecting = true
  removeToken() // removeToken 已同时清除 token 和 user
  // 延迟跳转，确保用户看到提示消息
  setTimeout(() => {
    router.push('/login').catch(() => {})
    isRedirecting = false
  }, 1500)
}

export default request
